import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { Buttoms, DefaultListOrder } from '../../../../private/shared/models/order-list';
import { IProductos } from '../../../../private/shared/models/productos';

@Component({
  selector: 'row-product',
  templateUrl: './row-product.component.html',
  styleUrls: ['./row-product.component.scss'],
})
export class RowProductComponent implements OnInit, OnChanges {

  @Input() product: IProductos = {} as IProductos;
  @Input() clase = '';
  @Input() rangeSelector = false;
  @Input() productsUsesReference = 0;
  @Input() maxRange = 0;

  @Output() productUse = new EventEmitter<IProductos>()

  public colDescrip = window.innerWidth >= 320 && window.innerWidth < 360 ? 5 : 6;
  public colButtoms = window.innerWidth >= 320 && window.innerWidth < 360 ? 4 : 3;
  public rangeInput: Buttoms = DefaultListOrder.componentContent.range.buttoms;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // Calcula el maximo de rango por producto
    const maxRange = changes.hasOwnProperty('maxRange') ? changes.maxRange.currentValue : this.maxRange;
    const productsUsesReference = changes.hasOwnProperty('productsUsesReference') ? changes.productsUsesReference.currentValue : this.productsUsesReference;
    this.rangeInput = { ...this.rangeInput, end: maxRange + productsUsesReference };
  }

  /** Retorna la seleccion del producto */
  public comeBack = (productSelect: number, product: IProductos) => this.productUse.next({ ...product, productos: productSelect })

}
